bz_app.controller('CityPermitMapAndListCtrl', [
  '$scope',
  function ($scope) {
    $scope.init = function (location) {
      $scope.location = location
    }
  },
])
